import { useVendors } from '@/composables/app/useVendors'
import { get as _get } from 'lodash'

const { getVendorRegexExpression } = useVendors()

const expressions = {
  link: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-zA-Z]{2,}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
  youtube: getVendorRegexExpression({ name: 'youtube', flags: 'g' }),
  vimeo: getVendorRegexExpression({ name: 'vimeo', flags: 'g' }),
  dailymotion: getVendorRegexExpression({ name: 'dailymotion', flags: 'g' }),
  iframe: /^<iframe(.)+<\/iframe>$/g
}

export default name => {
  return _get(expressions, name)
}